import styled from "styled-components"

const LeftTriangle = styled.div`
  width: 0px;
  height: 0px;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-right: 15px solid ${(props) => props.color};
  position: absolute;
  top: 10px;
  left: -15px;
`

export default LeftTriangle
